import { ErrorHandler, Injectable } from '@angular/core';
import { NotificationService } from '@progress/kendo-angular-notification';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { environment } from 'environments/environment';

export interface AppError {
  message: string;
  statusText?: string;
  error?: {
    error?: string;
    errors?: {
      msg?: string;
    }[];
  };
}

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {
  currentError = '';

  constructor(
    private _notificationService: NotificationService,
    private _authenticationService: AuthenticationService
  ) {}

  handleError(error: AppError): void {
    if (!environment.production) {
      // eslint-disable-next-line no-console
      console.error('error !!!');
      // eslint-disable-next-line no-console
      console.error(error);
    }

    if (environment.production) {
      if (error.message?.includes('Uncaught (in promise)')) {
        return;
      }
    }

    if (error.message?.includes('Login required')) {
      this._authenticationService.logout();
      return;
    }

    if (error.message !== this.currentError) {
      const errorTitle = ErrorHandlerService.getErrorTitle(error);
      const errorText = ErrorHandlerService.getErrorsText(error?.error);
      const content = errorTitle + (errorText ? `: ${errorText}` : '');
      this._notificationService.show({
        content,
        hideAfter: 2000,
        position: { horizontal: 'right', vertical: 'top' },
        animation: { type: 'fade', duration: 200 },
        type: { style: 'error', icon: true },
        closable: true,
        cssClass: 'rb-notification'
      });
      this.currentError = error.message;
      setTimeout(() => {
        this.currentError = '';
      }, 2000);
    }
  }

  static getErrorTitle(error: AppError): string {
    const title = (error.statusText || error.message) ?? 'Error';

    switch (title) {
      case 'OK':
        return 'Error';
      case 'Unknown Error':
        return 'Service unavailable, please try again later';
      default:
        return title;
    }
  }

  static getErrorsText(error: any): string {
    try {
      if (error?.errors && error?.errors?.length) {
        return error.errors.map((err: any) => err.msg).join(', ');
      } else if (error?.error) {
        return error.error.message || error.error;
      }

      return '';
    } catch (e) {
      if (!environment.production) {
        // eslint-disable-next-line no-console
        console.warn(e);
      }
      return '';
    }
  }
}
